<div class="item-list-component" [ngClass]="{ 'dx-rtl': rtlEnabled }" dir="{{rtlEnabled ? 'rtl' : 'ltr'}}">
  <div class="grid-buttons">
    <dx-button hint="{{ 'SHARED.ADD' | translate }}" icon="add" (onClick)="add()"></dx-button>
    <dx-button hint="{{ 'SHARED.PRINT' | translate }}" icon="print" (onClick)="print()"></dx-button>
  </div>
  <br />
  <dx-data-grid #distributionNumberRangesGrid id="printSection" 
                [rtlEnabled]="rtlEnabled" 
                [dataSource]="distributionNumberRangeDataSource"
                [showBorders]="true"
                [allowColumnReordering]="true"
                [hoverStateEnabled]="true"
                [columnAutoWidth]="true"
                [rowAlternationEnabled]="true"
                (onRowClick)="edit($event)"
                (onExporting)="onExporting($event)"
                [remoteOperations]="{ paging: true, filtering: true, sorting: true, search: true }"
                [paging]="{ pageSize: 20 }">
    <dxo-export [enabled]="true"></dxo-export>
    <dxo-selection mode="single"></dxo-selection>
    <dxo-filter-row [visible]="true"></dxo-filter-row>
    <dxo-filter-panel [visible]="true"></dxo-filter-panel>
    <dxo-header-filter [visible]="true"></dxo-header-filter>
    <dxo-search-panel [visible]="true"></dxo-search-panel>
    <dxo-pager [visible]="true"
               [showPageSizeSelector]="true"
               [allowedPageSizes]="[5, 10, 20, 30, 40, 50, 100, 200]"
               [showNavigationButtons]="true"
               [showInfo]="true"
               infoText="{2} {{ 'SHARED.PAGINATION_TEXT_PLACEHOLDER' | translate | slice:2 }}">
    </dxo-pager>
    <dxi-column dataField="masterDataListRowId" caption="{{ 'DISTRIBUTION_MANAGEMENT.CATEGORY' | translate }}">
      <dxo-lookup
      [dataSource]="masterDataLookupSource"
      valueExpr="value"
      displayExpr="label">
      </dxo-lookup>
    </dxi-column>
    
    <dxi-column dataField="distributionNumberRangeType" 
      caption="{{ 'DISTRIBUTION_MANAGEMENT.DISTRIBUTION_NUMBER_TYPE' | translate }}">
        <dxo-lookup
        [dataSource]="[
          { value: 0, label: 'DISTRIBUTION_MANAGEMENT.FIXED' | translate },
          { value: 1, label: 'DISTRIBUTION_MANAGEMENT.VARIABLE' | translate }
        ]"
        valueExpr="value"
        displayExpr="label">
        </dxo-lookup>
    </dxi-column>
    <dxi-column dataType="number" dataField="from" caption="{{ 'DISTRIBUTION_MANAGEMENT.FROM' | translate }}">
    </dxi-column>
    <dxi-column  dataType="number" dataField="till" caption="{{ 'DISTRIBUTION_MANAGEMENT.TILL' | translate }}">
    </dxi-column>
    
    <dxi-column type="buttons" [width]="70">
      <dxi-button hint="{{ 'SHARED.EDIT' | translate }}" icon="edit" [onClick]="edit" [disabled]="!editingEnabled"></dxi-button>
      <dxi-button hint="{{ 'SHARED.DELETE' | translate }}" icon="trash" [onClick]="deleteItem" [disabled]="!editingEnabled"></dxi-button>
    </dxi-column>

  </dx-data-grid>
</div>

<distribution-number-range-component #details (onClosed)="onDetailsComponentClosed($event)"></distribution-number-range-component>
<confirmation-component #confirmation title="{{ 'DISTRIBUTION_MANAGEMENT.DELETE' | translate }}"
                        message="{{ 'DISTRIBUTION_MANAGEMENT.DELETE_MESSAGE_DISTRIBUTION_NUMBER_RANGES' | translate }}"
                        buttonCloseText="{{ 'SHARED.DELETE' | translate }}" cancellable="true" (close)="deleteSelected();"></confirmation-component>
